import { HorizontalFlexContainer, PaneTitle, VerticalFlexContainer } from '@tableau/data-catalog-shared';
import * as React from 'react';

export interface PaneWithTitleProps {
  readonly title: string;
  readonly children: JSX.Element;
}

export const TitleTestId = 'pane-title';

/**
 * A generic pane with a title at the top and a child (usually a data grid) that fills up the rest of the space.
 */
export function PaneWithTitle(props: PaneWithTitleProps): JSX.Element {
  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <PaneTitle>
        <HorizontalFlexContainer>
          <span data-tb-test-id={TitleTestId}>{props.title}</span>
        </HorizontalFlexContainer>
      </PaneTitle>
      {props.children}
    </VerticalFlexContainer>
  );
}

